import { t } from "@/i18n-js/instance";
import { Toolbar } from "@circle-react/components/LiveStreams/Room/Toolbar";
import { useConfirmModal } from "@circle-react/components/LiveStreams/Room/hooks";
import { usePublicLiveStoreActions } from "../store";

export const LeaveButton = () => {
  const { leaveStream } = usePublicLiveStoreActions();
  const { confirmModal, onConfirmButtonClick } = useConfirmModal({
    title: t(`live_streams.pre_join.stream.hang_up_confirmation`),
    onConfirm: leaveStream,
  });

  return (
    <>
      {confirmModal}
      <Toolbar.Button
        aria-label={t("live_streams.room.button_tooltips.leave")}
        onClick={onConfirmButtonClick}
        icon="live-leave"
        label={t("live_streams.room.leave")}
      />
    </>
  );
};
